import React, { useContext } from "react";
import BasicAccountApplicationAPI from "../../api/commercial/basic-account-application";
import { LanguageContext } from "../../context/languageContext";
import { ErrorContext } from "../../route/error/provider";
import { HomeModel } from "../home/types";
import { mapDataToCreateBasicAccountAppRequest } from "../shared/mappers";
import Registration from "./index";
import { RegistrationModel } from "./types";
import { defaults } from "./account-form/defaults";
import { ProductContext } from "../../context/product-context/productContext";

interface PropTypes {
  homeModel: HomeModel;
  previous: () => void;
  next: (model: RegistrationModel) => void;
}

const UpdateContactInformationAdapter = (
  props: PropTypes,
): React.JSX.Element => {
  const { previous, next, homeModel } = props;
  const { selectedProduct } = useContext(ProductContext);
  const companyName = homeModel.isCompanyManuallyEntered
    ? homeModel.manuallyEnteredCompany.name
    : homeModel.selectedCompany.name;

  const company = homeModel.isCompanyManuallyEntered
    ? homeModel.manuallyEnteredCompany
    : homeModel.selectedCompany;

  const { language } = useContext(LanguageContext);
  const { setError } = useContext(ErrorContext);

  return (
    <Registration
      isUpdateMode
      initial={defaults}
      context={{
        terms: [],
        companyName,
      }}
      previous={previous}
      submitHandler={async (model: RegistrationModel) => {
        try {
          await BasicAccountApplicationAPI.create(
            mapDataToCreateBasicAccountAppRequest(
              language,
              selectedProduct?.productRef,
              company,
              model.admin,
              false,
            ),
          );
        } catch (e) {
          setError(e);
        }

        next(model);
      }}
    />
  );
};

export default UpdateContactInformationAdapter;
